import {Injectable} from "@angular/core";
import {TranslateService} from "ng2-translate";
import {BehaviorSubject} from "rxjs";

@Injectable()
export class LoadingService {
    public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public loadingMessage$: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);

    private actionTimeout: any;

    constructor(private translate: TranslateService) {
        console.log("--- LoadingService");
    }

    public async performWithSpinner(action: () => Promise<any>, duration: number = 10000, messageKey?: string, messageParams?: any, dismissAfterAction: boolean = true): Promise<any> {
        if (duration > 0) {
            await this.startSpinner(duration, messageKey, messageParams);
        }
        try {
            const loadResult: any = await action();
            if (dismissAfterAction) {
                this.dismissSpinner();
            }
            return loadResult;
        } catch (error) {
            this.dismissSpinner();
            throw error;
        }
    }

    public async startSpinner(duration: number = 10000, messageKey?: string, messageParams?: any): Promise<void> {
        const message: string = messageKey ? await this.translate.get(messageKey, messageParams).toPromise() : undefined;
        this.clearTimeout();
        this.loading$.next(true);
        this.loadingMessage$.next(message);
        if (duration) {
            this.actionTimeout = setTimeout(() => this.dismissSpinner(), duration);
        }
    }

    public dismissSpinner(): void {
        this.clearTimeout();
        this.loading$.next(false);
        this.loadingMessage$.next(undefined);
    }

    private clearTimeout(): void {
        if (this.actionTimeout) {
            clearTimeout(this.actionTimeout);
            this.actionTimeout = undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/loading/loading.service.ts